import { createContext, useContext } from 'react'

import type { CopyShellEnvelope } from './copy-fetch'

export const CopyContext = createContext<CopyShellEnvelope | null>(null)

export function useCopy(): CopyShellEnvelope {
  const ctx = useContext(CopyContext)
  if (!ctx) {
    throw new Error('useCopy() must be used inside <CopyProvider>')
  }
  return ctx
}
